<div class="overlay" *ngIf="visible">
	<div class="overlay-card">
		<button class="close-btn" (click)="dismiss()">&times;</button>
		<h2 class="headline">Register and have support anywhere</h2>
		<p class="text">Download the app to access your EAP resources &ndash; always available when you or your family needs it.</p>
		<div class="download-content">
			<div class="qr-code" *ngIf="data['QR Code']">
				<img [src]="data['QR Code']" alt="QR Code" />
			</div>
			<div class="app-links">
				<div class="scan-label" *ngIf="data['QR Code']">
					<img src="/assets/images/download-arrow.png" alt="" />
					<p>Scan to download</p>
				</div>
				<ul>
					<li *ngIf="data['Google Play Link']">
						<a [href]="data['Google Play Link']" target="_blank">
							<img src="/assets/images/Google-Play_x2.png" alt="Get it on Google Play" />
						</a>
					</li>
					<li *ngIf="data['Apple Store Link']">
						<a [href]="data['Apple Store Link']" target="_blank">
							<img src="/assets/images/App-Store_x2.png" alt="Download on the App Store" />
						</a>
					</li>
				</ul>
			</div>
		</div>
		<p class="group-code" *ngIf="groupCode"><b [innerHTML]="groupCodeLabel || 'Enter group code'"></b>:&nbsp;{{ groupCode }}</p>
		<a *ngIf="eapUrl" class="register-btn" [href]="eapUrl" target="_blank" (click)="dismiss()">Register</a>
	</div>
</div>
